import { sortSummaryData, formatToLocalDateTime } from '../utils';
import { CustomDatePicker } from '../../../../components';
import { formatPrice } from '../../price-processing.utils';
import { GlobalPriceTableProps } from './GlobalPriceTable.types';

/**
 * Renders a global price processing table with editable price inputs and date controls
 * Displays regional, provincial, and brand data with fuel prices and last update times
 */
export function GlobalPriceTable({
  data,
  fuelTypes,
  canProcessOkkoPrices,
  bodyRef,
  isCellChanged,
  handlePriceInput,
  onDateChange,
  resetKey = ''
}: GlobalPriceTableProps): JSX.Element {
  const sortedData = sortSummaryData(data);

  return (
    <div className="price-processing-summary-table-wrapper" ref={bodyRef}>
      <div className="price-processing-table">
        {sortedData.map((item, index) => (
          <div key={index} className={`price-processing-table-row ${item.isOkko ? 'okko-row' : ''}`}>
            <div className="price-processing-table-cell price-processing-region-col">{item.region}</div>
            <div className="price-processing-table-cell price-processing-province-col">{item.province}</div>
            <div className="price-processing-table-cell price-processing-brand-col">{item.brand}</div>
            <div className="price-processing-table-cell price-processing-last-date-col">
              {formatToLocalDateTime(item.lastUpdate)}
            </div>
            {fuelTypes.map(fuel => (
              <div
                key={fuel}
                className={`price-processing-table-cell price-processing-fuel-col ${isCellChanged(item, fuel) ? 'cell-changed' : ''}`}
              >
                {item.isEditable && !(item.isOkko && fuel === 'AdBlue') ? (
                  <input
                    type="text"
                    className={`price-input ${item.isOkko && !canProcessOkkoPrices ? 'not-allowed' : ''}`}
                    disabled={item.isOkko && !canProcessOkkoPrices}
                    value={formatPrice(item.prices[fuel])}
                    onChange={e => handlePriceInput(e, item, fuel)}
                  />
                ) : (
                  <span className="price-display">
                    {item.isOkko && fuel === 'AdBlue' ? '' : formatPrice(item.prices[fuel] || 0) || '-'}
                  </span>
                )}
              </div>
            ))}
            <div
              className={`price-processing-table-cell price-processing-date-col ${isCellChanged(item, 'date') ? 'cell-changed' : ''}`}
            >
              {item.isEditable && !(item.isOkko && !canProcessOkkoPrices) ? (
                <CustomDatePicker
                  key={`${index}-${resetKey}`}
                  value={item.changeDate ? new Date(item.changeDate) : null}
                  onChange={value => onDateChange(item, value as string)}
                  format="dd.MM.yyyy HH:mm:ss"
                  showTime={true}
                  timeFormat="HH:mm:ss"
                  includeSeconds={true}
                  outputFormat="datetime-local"
                />
              ) : (
                <span>{formatToLocalDateTime(item.changeDate)}</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
